'use client'

import { motion } from 'motion/react'
import Image from 'next/image'
import { categoryLabelFa } from '../templates-copy-fa'
import type { Template } from '../types'

interface TemplateCardProps {
    template: Template
    onClick: () => void
}

export function TemplateCard({ template, onClick }: TemplateCardProps) {
    return (
        <motion.button
            type="button"
            onClick={onClick}
            whileHover={{ y: -4 }}
            transition={{ duration: 0.2 }}
            className="group block w-full cursor-pointer text-start outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 rounded-md">
            <div className="card-border bg-muted/40 relative aspect-[3/4] overflow-hidden rounded-md">
                <Image
                    src={template.image}
                    alt={template.title}
                    fill
                    sizes="(max-width: 640px) 100vw, (max-width: 1024px) 50vw, (max-width: 1280px) 33vw, 280px"
                    className="object-cover transition-transform duration-300 group-hover:scale-[1.03]"
                />
            </div>
            <div className="mt-3 flex items-start justify-between gap-2 px-0.5">
                <div className="min-w-0 flex-1">
                    <h3 className="line-clamp-1 text-sm font-medium">        {template.icon}{template.title}</h3>
                    <p className="text-muted-foreground mt-0.5 line-clamp-1 text-xs">{categoryLabelFa(template.category)}</p>
                </div>

            </div>
        </motion.button>
    )
}
